module.exports = __webpack_public_path__ + "static/media/key.7d03fa36.svg";